"use strict";
/**
 * @module diffusion.datatypes
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var decoder_1 = require("./../../cbor/decoder");
var primitive_datatype_1 = require("./../../data/primitive/primitive-datatype");
/**
 * Serialise an double value into a CBOR encoder
 *
 * @param value    the value to serialise
 * @param encoder  the encoder
 */ // tslint:disable-next-line:ban-types
function serialise(value, encoder) {
    if (value === null || value === undefined) {
        encoder.encode(null);
    }
    else {
        encoder.writeDouble(value);
    }
}
/**
 * A data type for double values
 */ // tslint:disable-next-line:ban-types
var DoubleDataTypeImpl = /** @class */ (function (_super) {
    __extends(DoubleDataTypeImpl, _super);
    /**
     * Create a new DoubleDataType instance
     */
    function DoubleDataTypeImpl() {
        return _super.call(this, 'double', Number, serialise, decoder_1.isDouble, false) || this;
    }
    return DoubleDataTypeImpl;
}(primitive_datatype_1.PrimitiveDataType));
exports.DoubleDataTypeImpl = DoubleDataTypeImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/data/primitive/double-datatype-impl.js
// module id = 1249
// module chunks = 0